import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {ErrorMargins} from '../../../models/error-margins.interface';
import {ErrorMarginsService} from '../../../services/error-margins.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl} from '@angular/forms';

@Component({
  selector: 'app-edit-error',
  templateUrl: './edit-error.component.html',
  styleUrls: ['./edit-error.component.scss']
})
export class EditErrorComponent implements OnInit {

  @Output()
  updateEvent: EventEmitter<void> = new EventEmitter<void>();

  errorEditForm = this.formBuilder.group({
    percentage: [null],
  });

  get percentageControl(): FormControl {
    return this.errorEditForm.get('percentage') as FormControl;
  }


  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorMargins,
              private dialogRef: MatDialogRef<EditErrorComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly errorService: ErrorMarginsService) { }

  ngOnInit(): void {
    if (this.data.percentage) {
      this.percentageControl.setValue(this.data.percentage);
    }
  }

  sendEditionRequest(): void {
    const dto: ErrorMargins | null = this.getEditionDto();
    if (dto) {
      this.errorService.editError(dto).subscribe(
        () => {
          this.updateEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }
  closeDialog(): void {
    this.dialogRef.close();
  }

  private getEditionDto(): ErrorMargins {
    return {
      id: this.data.id,
      keyFigures: this.data.keyFigures,
      percentage: this.percentageControl.value === null ? 0 : this.percentageControl.value,
    };
  }

}
